import React from "react";
import verify from "../assets/verified.png";
import { VslTestimonialImages, VslTestimonials } from "../constant/data";

const Testimonials = () => {
    return (
        <div className="bg-[#F4F5F7]">
          {/* Section visible only on small screens */}
<div className="block lg:hidden mx-auto px-8 space-y-5 py-12 max-w-7xl">
  <div className="w-full flex items-center justify-center">
    <div className="w-60 h-4 bg-[#132C4D]" />
  </div>
  <h2 className="font-bold text-4xl text-center leading-[48px]">
    Real Respoclear Users. Real Life-Changing Results
  </h2>
  <div className="flex flex-wrap justify-center px-1">
    {VslTestimonialImages.map((image) => (
      <div
        key={image.id}
        className="w-1/2 md:w-1/2 lg:w-1/4 px-[2px] flex justify-center"
      >
        <div className="lg:w-60 lg:h-60 w-48 h-48 shadow-lg border-[6px] border-b-[16px] border-white shadow-custom transform rotate-[-4deg]">
          <img
            src={image.src}
            alt={image.alt}
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    ))}
  </div>
</div>

{/* Section visible only on large screens */}
<div className="hidden lg:block mx-auto px-8 space-y-5 py-12 max-w-7xl">
  <div className="w-full flex items-center justify-center">
    <div className="w-60 h-4 bg-[#132C4D]" />
  </div>
  <h2 className="font-bold md:text-4xl text-2xl text-center">
    Real Respoclear Users. Real Life-Changing Results
  </h2>
  <div className="flex flex-wrap justify-center">
    {VslTestimonialImages.map((image) => (
      <div
        key={image.id}
        className="lg:w-60 lg:h-60 w-48 h-48 shadow-lg border-[6px] border-b-[16px] border-white shadow-custom transform rotate-[-4deg]"
      >
        <img
          src={image.src}
          alt={image.alt}
          className="w-full lg:h-56 h-48 object-cover"
        />
      </div>
    ))}
  </div>
</div>

            <div className="mx-auto max-7xl px-4 pb-10 space-y-5">
                <div className="max-w-xl mx-auto space-y-6">
                    {VslTestimonials.map((testimonial) => (
                        <div
                            key={testimonial.id}
                            className="flex md:items-start items-center md:flex-row flex-col gap-4 px-4 py-6 border border-black rounded-2xl">
                            <img
                                src={testimonial.img}
                                alt={`${testimonial.name}`}
                                className="w-24 rounded-full object-cover"
                            />
                            <div className="space-y-2">
                                <p className="text-base font-light md:text-start text-center text-[#212529]">
                                    {testimonial.text}
                                </p>
                                <h1 className="text-xl md:text-start text-center font-bold">
                                    {testimonial.name}
                                </h1>
                                <div className="md:justify-normal justify-center w-full flex">
                                <img src={verify} alt="Verified" className="w-44" />

                                    </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Testimonials;
